import Vue from 'vue'
import moment from 'moment'
export const state = {
  flights: {},
  selectedFlightId: null,
  selectedFlightDate: { startDate: moment(), endDate: moment() },
}

export const mutations = {
  SET_SELECTED_FLIGHT_ID(state, flightId) {
    state.selectedFlightId = flightId
  },
  SET_SELECTED_FLIGHT_DATE(state, date) {
    state.selectedFlightDate = date
  },
  SET_FLIGHTS(state, flights) {
    flights.forEach((flight) => {
      Vue.set(state.flights, flight.FlightId, flight)
    })
  },
}

export const getters = {
  getSelectedFlightId(state) {
    return state.selectedFlightId
  },
  getSelectedFlightDate(state) {
    return state.selectedFlightDate
  },
  getFlights(state) {
    return state.flights
  },
  getFlightById: (state) => (flightId) => {
    return state.flights[flightId]
  },
}

export const actions = {
  // Logs in the current user.
  SET_SELECTED_FLIGHT_ID({ commit, dispatch, getters }, flightId) {
    commit('SET_SELECTED_FLIGHT_ID', flightId)
  },
  SET_SELECTED_FLIGHT_DATE({ commit, dispatch, getters }, date) {
    commit('SET_SELECTED_FLIGHT_DATE', date)
  },
  SET_FLIGHTS({ commit, dispatch, getters }, flights) {
    commit('SET_FLIGHTS', flights)
  },
}
